<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="OT">Contents</p>
<p class="CON2AFTER"><a href="#/CoverImage">Cover</a></p>
<p class="CON2AFTER"><a href="#/Dedication">Dedication</a></p>
<p class="CON2AFTER" id="toc1"><a href="#/Wright_Who_Was_Jesus_text2#toc_marker-3">Preface</a></p>
<p class="CON2" id="toc2"><a href="#/Wright_Who_Was_Jesus_text3#toc_marker-4">1. The Portraits and the Puzzles</a></p>
<p class="CON2" id="toc3"><a href="#/Wright_Who_Was_Jesus_text4#toc_marker-5">2. Barbara Thiering: Jesus in Code</a></p>
<p class="CON2" id="toc4"><a href="#/Wright_Who_Was_Jesus_text5#toc_marker-6">3. A. N. Wilson: A Moderately Pale Galilean</a></p>
<p class="CON2" id="toc5"><a href="#/Wright_Who_Was_Jesus_text6#toc_marker-7">4. John Spong: The Bishop and the Birth</a></p>
<p class="CON2" id="toc6"><a href="#/Wright_Who_Was_Jesus_text7#toc_marker-8">5. Jesus Revisited</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wright_Who_Was_Jesus_text-1.vue?5c650a15